import theme from 'theme'

const ActiveCPIIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M2.625 7.4375L6.125 10.9375L11.375 3.0625"
      stroke={theme.colors.white}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ActiveCPIIcon
